var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.showDetailPage
        ? _c(
            "div",
            [
              _c("h2", { staticClass: "page-title-bar" }, [
                _c("img", {
                  staticStyle: { "margin-right": "10px", width: "28px" },
                  attrs: { src: require("@/assets/img/camera.png") }
                }),
                _vm._v(" " + _vm._s(_vm.$t("Shelf Monitoring")) + " ")
              ]),
              _c(
                "div",
                { staticClass: "mt-5 shelf-monitoring-overview" },
                [
                  _c("v-card", { staticClass: "monitor-card" }, [
                    _c("div", { staticClass: "monitor-card-title" }, [
                      _vm._v(" " + _vm._s(_vm.$t("Shelf Status")) + " ")
                    ]),
                    _c(
                      "div",
                      { staticClass: "chart-flex-container px-4 pb-3" },
                      [
                        _c("div", { staticClass: "chart-left-section" }, [
                          _c(
                            "div",
                            { staticClass: "chart-container-wrapper" },
                            [
                              _vm.hasDonutData
                                ? [
                                    _c("apexchart", {
                                      attrs: {
                                        type: "donut",
                                        height: "280",
                                        options: _vm.statusChartOptions,
                                        series: _vm.statusSeries
                                      }
                                    }),
                                    _c(
                                      "div",
                                      { staticClass: "chart-center-text" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "center-title" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("Total")) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "center-count" },
                                          [
                                            _vm._v(
                                              " " + _vm._s(_vm.totalCount) + " "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                : _c(
                                    "div",
                                    { staticClass: "empty-donut-state" },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "mdi mdi-chart-bar empty-donut-icon"
                                      }),
                                      _c(
                                        "p",
                                        { staticClass: "empty-donut-text" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("No data available"))
                                          )
                                        ]
                                      )
                                    ]
                                  )
                            ],
                            2
                          )
                        ]),
                        _c(
                          "div",
                          { staticClass: "chart-right-section" },
                          _vm._l(_vm.statusItems, function(item) {
                            return _c(
                              "div",
                              { key: item.label, staticClass: "status-item" },
                              [
                                _c("div", { staticClass: "item-title pt-1" }, [
                                  _c("span", {
                                    staticClass: "status-dot",
                                    style: { background: item.color }
                                  })
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticClass: "d-flex flex-column",
                                    staticStyle: { gap: "12px" }
                                  },
                                  [
                                    _c("div", { staticClass: "item-label" }, [
                                      _vm._v(" " + _vm._s(item.label) + " ")
                                    ]),
                                    _c("div", { staticClass: "item-value" }, [
                                      _vm._v(" " + _vm._s(item.count) + " ")
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "item-percentage" },
                                      [
                                        _vm._v(
                                          "(" + _vm._s(item.percent) + "%)"
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    )
                  ]),
                  _c("v-card", { staticClass: "monitor-card" }, [
                    _c("div", { staticClass: "monitor-card-head" }, [
                      _c(
                        "div",
                        { staticClass: "pa-0 ma-0 monitor-card-title" },
                        [_vm._v(" " + _vm._s(_vm.$t("Shelf Trend")) + " ")]
                      ),
                      _c("div", { staticClass: "trend-tools" }, [
                        _c("div", { staticClass: "trend-legend" }, [
                          _c("span", { staticClass: "legend-item" }, [
                            _c("i", { staticClass: "legend-dot oos" }),
                            _vm._v(" " + _vm._s(_vm.$t("OOS")) + " ")
                          ]),
                          _c("span", { staticClass: "legend-item" }, [
                            _c("i", { staticClass: "legend-dot low" }),
                            _vm._v(" " + _vm._s(_vm.$t("Low")) + " ")
                          ]),
                          _c("span", { staticClass: "legend-item" }, [
                            _c("i", { staticClass: "legend-dot misplaced" }),
                            _vm._v(" " + _vm._s(_vm.$t("Misplaced")) + " ")
                          ])
                        ]),
                        _c(
                          "div",
                          { staticClass: "trend-range-toggle" },
                          _vm._l(_vm.ranges, function(range) {
                            return _c(
                              "button",
                              {
                                key: range,
                                staticClass: "trend-range-btn",
                                class: { active: _vm.selectedRange === range },
                                on: {
                                  click: function($event) {
                                    _vm.selectedRange = range
                                  }
                                }
                              },
                              [_vm._v(" " + _vm._s(range) + " ")]
                            )
                          }),
                          0
                        )
                      ])
                    ]),
                    _vm.trendSeries.length
                      ? _c(
                          "div",
                          [
                            _c("apexchart", {
                              attrs: {
                                type: "bar",
                                width: "100%",
                                height: "240",
                                options: _vm.trendOptions,
                                series: _vm.trendSeries
                              }
                            })
                          ],
                          1
                        )
                      : _c("div", { staticClass: "empty-chart-state" }, [
                          _c("i", {
                            staticClass: "mdi mdi-chart-bar empty-icon"
                          }),
                          _c("p", { staticClass: "empty-text" }, [
                            _vm._v(_vm._s(_vm.$t("No data available")))
                          ])
                        ])
                  ])
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "pa-3", attrs: { "no-gutters": "" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "d-flex align-center justify-center",
                      attrs: { cols: "2" }
                    },
                    [
                      _c(
                        "v-menu",
                        {
                          attrs: {
                            "offset-y": "",
                            "close-on-content-click": false,
                            "content-class": "columnMenu"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass: "manage-btn btn",
                                            attrs: { text: "", small: "" }
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("Manage Columns")) +
                                            " "
                                        ),
                                        _c(
                                          "v-icon",
                                          {
                                            class: { rotate: _vm.menuOpen },
                                            attrs: { right: "" }
                                          },
                                          [_vm._v(" mdi-chevron-down ")]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1404380584
                          ),
                          model: {
                            value: _vm.menuOpen,
                            callback: function($$v) {
                              _vm.menuOpen = $$v
                            },
                            expression: "menuOpen"
                          }
                        },
                        [
                          _c(
                            "v-card",
                            { staticClass: "column-card" },
                            [
                              _c(
                                "v-card-title",
                                { staticClass: "column-header" },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("Select Columns")) + " "
                                  )
                                ]
                              ),
                              _c("v-divider"),
                              _c(
                                "v-list",
                                {
                                  staticClass: "select-all",
                                  attrs: { dense: "" }
                                },
                                [
                                  _c(
                                    "v-list-item",
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          "input-value": _vm.isAllSelected,
                                          "hide-details": ""
                                        },
                                        on: { change: _vm.toggleSelectAll }
                                      }),
                                      _c("v-list-item-title", [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("Select All")) +
                                            " "
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c("v-divider"),
                              _c(
                                "v-card-text",
                                { staticClass: "column-list" },
                                [
                                  _c(
                                    "v-list",
                                    { attrs: { dense: "" } },
                                    _vm._l(_vm.headers.slice(3), function(
                                      header
                                    ) {
                                      return _c(
                                        "v-list-item",
                                        { key: header.value },
                                        [
                                          _c("v-checkbox", {
                                            attrs: {
                                              value: header.text,
                                              "hide-details": ""
                                            },
                                            model: {
                                              value: _vm.visibleColumns,
                                              callback: function($$v) {
                                                _vm.visibleColumns = $$v
                                              },
                                              expression: "visibleColumns"
                                            }
                                          }),
                                          _c(
                                            "v-list-item-title",
                                            { staticClass: "column-text" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(header.text) + " "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              ),
                              _c("v-divider"),
                              _c(
                                "v-card-actions",
                                { staticClass: "column-footer" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticStyle: {
                                        background: "#c57171",
                                        color: "#ffffff !important",
                                        width: "80px"
                                      },
                                      attrs: {
                                        color: "error",
                                        text: "",
                                        small: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.menuOpen = false
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("Cancel")) + " "
                                      )
                                    ]
                                  ),
                                  _c("v-spacer"),
                                  _c(
                                    "v-btn",
                                    {
                                      staticStyle: { width: "80px" },
                                      attrs: { color: "primary", small: "" },
                                      on: {
                                        click: function($event) {
                                          _vm.menuOpen = false
                                          _vm.saveVisibleColumns()
                                        }
                                      }
                                    },
                                    [_vm._v(" " + _vm._s(_vm.$t("Save")) + " ")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "d-flex align-center justify-center",
                      attrs: { cols: "1" }
                    },
                    [
                      _c("v-divider", {
                        staticClass: "mx-4",
                        attrs: { vertical: "" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "9" } },
                    [
                      _c(
                        "v-row",
                        { staticClass: "mb-3" },
                        [
                          _c(
                            "v-col",
                            { staticClass: "py-0", attrs: { cols: "4" } },
                            [
                              _c("v-select", {
                                staticClass: "form-select",
                                attrs: {
                                  "hide-details": "",
                                  items: _vm.floors,
                                  label: _vm.$t("Floor"),
                                  placeholder: _vm.$t("Select Floor"),
                                  outlined: "",
                                  dense: "",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.filter.floor,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "floor", $$v)
                                  },
                                  expression: "filter.floor"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "py-0", attrs: { cols: "4" } },
                            [
                              _c("v-select", {
                                staticClass: "form-select",
                                attrs: {
                                  "hide-details": "",
                                  items: _vm.errors,
                                  "item-title": "text",
                                  "item-value": "value",
                                  label: _vm.$t("Error"),
                                  placeholder: _vm.$t("Select Error"),
                                  outlined: "",
                                  dense: "",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.filter.error,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "error", $$v)
                                  },
                                  expression: "filter.error"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "d-flex align-end py-0" },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "btn type-search",
                                  attrs: { text: "" },
                                  on: { click: _vm.searchData }
                                },
                                [_vm._v(" " + _vm._s(_vm.$t("Search")) + " ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { staticClass: "py-0", attrs: { cols: "4" } },
                            [
                              _c("v-text-field", {
                                staticClass: "form-input",
                                attrs: {
                                  "hide-details": "",
                                  label: _vm.$t("Shelf Group ID"),
                                  placeholder: _vm.$t("Input Shelf Group ID"),
                                  outlined: "",
                                  dense: "",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.filter.shelfId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "shelfId", $$v)
                                  },
                                  expression: "filter.shelfId"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "py-0", attrs: { cols: "4" } },
                            [
                              _c("v-select", {
                                staticClass: "form-select",
                                attrs: {
                                  "hide-details": "",
                                  items: _vm.statusOptions,
                                  "item-title": "text",
                                  "item-value": "value",
                                  label: _vm.$t("Status"),
                                  placeholder: _vm.$t("Select Status"),
                                  outlined: "",
                                  dense: "",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.filter.status,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "status", $$v)
                                  },
                                  expression: "filter.status"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "d-flex align-end py-0" },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "btn type-search",
                                  attrs: { text: "" },
                                  on: { click: _vm.clearFilters }
                                },
                                [_vm._v(" " + _vm._s(_vm.$t("Clear")) + " ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-data-table", {
                staticClass: "tbl-type01 mt-6 products",
                attrs: {
                  headers: _vm.filteredHeaders,
                  items: _vm.tableItems,
                  "item-key": "shelfGroupId",
                  "fixed-header": "",
                  "item-class": _vm.getRowClass,
                  "hide-default-footer": true
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "item.expand",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          !item.isChild && item.children && item.children.length
                            ? _c(
                                "v-btn",
                                {
                                  attrs: { icon: "", small: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.toggleExpand(item)
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.expandedRows.includes(item.id)
                                            ? "mdi-chevron-up"
                                            : "mdi-chevron-down"
                                        ) +
                                        " "
                                    )
                                  ])
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      }
                    },
                    {
                      key: "item.outOfStock",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _c(
                            "span",
                            {
                              class: {
                                "txt-danger": Number(item.outOfStock) > 0
                              }
                            },
                            [_vm._v(" " + _vm._s(item.outOfStock || 0) + " ")]
                          )
                        ]
                      }
                    },
                    {
                      key: "item.lowStock",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _c(
                            "span",
                            {
                              class: { "txt-stable": Number(item.lowStock) > 0 }
                            },
                            [_vm._v(" " + _vm._s(item.lowStock || 0) + " ")]
                          )
                        ]
                      }
                    },
                    {
                      key: "item.misplaced",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _c(
                            "span",
                            {
                              class: {
                                "txt-caution": Number(item.misplaced) > 0
                              }
                            },
                            [_vm._v(" " + _vm._s(item.misplaced || 0) + " ")]
                          )
                        ]
                      }
                    },
                    {
                      key: "item.details",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          !item.isChild
                            ? _c(
                                "v-icon",
                                {
                                  attrs: {
                                    disabled: _vm.btnDisabledDetails,
                                    small: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.openDetails(item)
                                    }
                                  }
                                },
                                [_vm._v("mdi-file-eye")]
                              )
                            : _vm._e()
                        ]
                      }
                    },
                    {
                      key: "item.status",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          item.msg && item.msg !== "-"
                            ? _c(
                                "v-tooltip",
                                {
                                  attrs: { top: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              "span",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    class: _vm.statusStyle(
                                                      item.status
                                                    ),
                                                    staticStyle: {
                                                      "font-weight": "600"
                                                    }
                                                  },
                                                  "span",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(item.status) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [_c("span", [_vm._v(_vm._s(item.msg))])]
                              )
                            : _c(
                                "span",
                                {
                                  class: _vm.statusStyle(item.status),
                                  staticStyle: { "font-weight": "600" }
                                },
                                [_vm._v(" " + _vm._s(item.status) + " ")]
                              )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1241567660
                )
              }),
              _c(
                "v-row",
                { staticClass: "mt-4" },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "d-flex justify-space-between align-end",
                      attrs: { cols: "12" }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn mr-2",
                              attrs: {
                                text: "",
                                disabled: _vm.btnDisabledDetails
                              },
                              on: {
                                click: function($event) {
                                  return _vm.captureScheSetting()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Schedule Settings")))]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn mr-2",
                              attrs: {
                                text: "",
                                disabled:
                                  _vm.btnDisabledExport ||
                                  _vm.tableItems.length === 0
                              },
                              on: {
                                click: function($event) {
                                  return _vm.exportRecords()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Export")))]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn mr-2",
                              attrs: {
                                text: "",
                                disabled: _vm.btnDisabledDetails
                              },
                              on: {
                                click: function($event) {
                                  return _vm.deleteRepeatSchedule()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Delete Repeat Schedule")))]
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c("Pagination", {
                            attrs: {
                              pageInfoText: _vm.pageInfoText,
                              pageIndex: _vm.pageIndex,
                              rowPerPage: _vm.rowPerPage,
                              goToPageInput: _vm.goToPageInput,
                              totalPages: _vm.totalPages
                            },
                            on: {
                              paging: function($event) {
                                return _vm.paging($event)
                              },
                              updatePage: function($event) {
                                return _vm.updatePage($event)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _c("a", { ref: "link", style: { display: "none" } })
            ],
            1
          )
        : _vm._e(),
      _vm.captureScheduleDetailsDailog
        ? _c("Capture-Schedule-Setting", {
            attrs: {
              captureScheduleDetailsDailog: _vm.captureScheduleDetailsDailog
            },
            on: {
              closeModalCapture: function($event) {
                _vm.captureScheduleDetailsDailog = false
              }
            }
          })
        : _vm._e(),
      _vm.showDetailPage
        ? _c("detailPage", {
            attrs: { "shelf-data": _vm.selectedShelf },
            on: {
              back: function($event) {
                _vm.showDetailPage = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }